/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { StripeBuyerOrgCreateSetupIntent } from '../model';
// @ts-ignore
import { Subscription } from '../model';
// @ts-ignore
import { SubscriptionCancelRequest } from '../model';
// @ts-ignore
import { SubscriptionChangeRequest } from '../model';
// @ts-ignore
import { SubscriptionCreateRequest } from '../model';
// @ts-ignore
import { SubscriptionCreateResponse } from '../model';
// @ts-ignore
import { SubscriptionPlan } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * OrganisationSubscriptionApi - axios parameter creator
 * @export
 */
export const OrganisationSubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the cancelled subscription details.
         * @summary Cancels the subscription of a buyer org
         * @param {string} buyerOrgId 
         * @param {SubscriptionCancelRequest} subscriptionCancelRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionCancelCreate: async (buyerOrgId: string, subscriptionCancelRequest: SubscriptionCancelRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgSubscriptionCancelCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'subscriptionCancelRequest' is not null or undefined
            assertParamExists('orgSubscriptionCancelCreate', 'subscriptionCancelRequest', subscriptionCancelRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/subscription/cancel`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionCancelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the updated subscription details.
         * @summary Update the subscription plan or payment method for a buyer org
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {SubscriptionChangeRequest} [subscriptionChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionChangeCreate: async (buyerOrgId: string, aaSource?: string, subscriptionChangeRequest?: SubscriptionChangeRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgSubscriptionChangeCreate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/subscription/change`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the created subscription details.
         * @summary Create a subscription for a buyer org
         * @param {string} buyerOrgId 
         * @param {SubscriptionCreateRequest} subscriptionCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionCreateCreate: async (buyerOrgId: string, subscriptionCreateRequest: SubscriptionCreateRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgSubscriptionCreateCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'subscriptionCreateRequest' is not null or undefined
            assertParamExists('orgSubscriptionCreateCreate', 'subscriptionCreateRequest', subscriptionCreateRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/subscription/create`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns setup intent, along with the customer and an ephemeral key
         * @summary Creates a new setup intent
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionCreateSetupIntentCreate: async (buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgSubscriptionCreateSetupIntentCreate', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/subscription/create-setup-intent`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the list of subscription plans
         * @summary List of all the available subscription plans
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionList: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/org/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationSubscriptionApi - functional programming interface
 * @export
 */
export const OrganisationSubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationSubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the cancelled subscription details.
         * @summary Cancels the subscription of a buyer org
         * @param {string} buyerOrgId 
         * @param {SubscriptionCancelRequest} subscriptionCancelRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgSubscriptionCancelCreate(buyerOrgId: string, subscriptionCancelRequest: SubscriptionCancelRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgSubscriptionCancelCreate(buyerOrgId, subscriptionCancelRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the updated subscription details.
         * @summary Update the subscription plan or payment method for a buyer org
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {SubscriptionChangeRequest} [subscriptionChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgSubscriptionChangeCreate(buyerOrgId: string, aaSource?: string, subscriptionChangeRequest?: SubscriptionChangeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgSubscriptionChangeCreate(buyerOrgId, aaSource, subscriptionChangeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the created subscription details.
         * @summary Create a subscription for a buyer org
         * @param {string} buyerOrgId 
         * @param {SubscriptionCreateRequest} subscriptionCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgSubscriptionCreateCreate(buyerOrgId: string, subscriptionCreateRequest: SubscriptionCreateRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgSubscriptionCreateCreate(buyerOrgId, subscriptionCreateRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns setup intent, along with the customer and an ephemeral key
         * @summary Creates a new setup intent
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgSubscriptionCreateSetupIntentCreate(buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeBuyerOrgCreateSetupIntent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgSubscriptionCreateSetupIntentCreate(buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the list of subscription plans
         * @summary List of all the available subscription plans
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgSubscriptionList(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubscriptionPlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgSubscriptionList(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationSubscriptionApi - factory interface
 * @export
 */
export const OrganisationSubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationSubscriptionApiFp(configuration)
    return {
        /**
         * Returns the cancelled subscription details.
         * @summary Cancels the subscription of a buyer org
         * @param {string} buyerOrgId 
         * @param {SubscriptionCancelRequest} subscriptionCancelRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionCancelCreate(buyerOrgId: string, subscriptionCancelRequest: SubscriptionCancelRequest, aaSource?: string, options?: any): AxiosPromise<Subscription> {
            return localVarFp.orgSubscriptionCancelCreate(buyerOrgId, subscriptionCancelRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the updated subscription details.
         * @summary Update the subscription plan or payment method for a buyer org
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {SubscriptionChangeRequest} [subscriptionChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionChangeCreate(buyerOrgId: string, aaSource?: string, subscriptionChangeRequest?: SubscriptionChangeRequest, options?: any): AxiosPromise<Subscription> {
            return localVarFp.orgSubscriptionChangeCreate(buyerOrgId, aaSource, subscriptionChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the created subscription details.
         * @summary Create a subscription for a buyer org
         * @param {string} buyerOrgId 
         * @param {SubscriptionCreateRequest} subscriptionCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionCreateCreate(buyerOrgId: string, subscriptionCreateRequest: SubscriptionCreateRequest, aaSource?: string, options?: any): AxiosPromise<SubscriptionCreateResponse> {
            return localVarFp.orgSubscriptionCreateCreate(buyerOrgId, subscriptionCreateRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns setup intent, along with the customer and an ephemeral key
         * @summary Creates a new setup intent
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionCreateSetupIntentCreate(buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<StripeBuyerOrgCreateSetupIntent> {
            return localVarFp.orgSubscriptionCreateSetupIntentCreate(buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the list of subscription plans
         * @summary List of all the available subscription plans
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgSubscriptionList(aaSource?: string, options?: any): AxiosPromise<Array<SubscriptionPlan>> {
            return localVarFp.orgSubscriptionList(aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgSubscriptionCancelCreate operation in OrganisationSubscriptionApi.
 * @export
 * @interface OrganisationSubscriptionApiOrgSubscriptionCancelCreateRequest
 */
export interface OrganisationSubscriptionApiOrgSubscriptionCancelCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCancelCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {SubscriptionCancelRequest}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCancelCreate
     */
    readonly subscriptionCancelRequest: SubscriptionCancelRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCancelCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgSubscriptionChangeCreate operation in OrganisationSubscriptionApi.
 * @export
 * @interface OrganisationSubscriptionApiOrgSubscriptionChangeCreateRequest
 */
export interface OrganisationSubscriptionApiOrgSubscriptionChangeCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionChangeCreate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionChangeCreate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {SubscriptionChangeRequest}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionChangeCreate
     */
    readonly subscriptionChangeRequest?: SubscriptionChangeRequest
}

/**
 * Request parameters for orgSubscriptionCreateCreate operation in OrganisationSubscriptionApi.
 * @export
 * @interface OrganisationSubscriptionApiOrgSubscriptionCreateCreateRequest
 */
export interface OrganisationSubscriptionApiOrgSubscriptionCreateCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCreateCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {SubscriptionCreateRequest}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCreateCreate
     */
    readonly subscriptionCreateRequest: SubscriptionCreateRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCreateCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgSubscriptionCreateSetupIntentCreate operation in OrganisationSubscriptionApi.
 * @export
 * @interface OrganisationSubscriptionApiOrgSubscriptionCreateSetupIntentCreateRequest
 */
export interface OrganisationSubscriptionApiOrgSubscriptionCreateSetupIntentCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCreateSetupIntentCreate
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionCreateSetupIntentCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgSubscriptionList operation in OrganisationSubscriptionApi.
 * @export
 * @interface OrganisationSubscriptionApiOrgSubscriptionListRequest
 */
export interface OrganisationSubscriptionApiOrgSubscriptionListRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationSubscriptionApiOrgSubscriptionList
     */
    readonly aaSource?: string
}

/**
 * OrganisationSubscriptionApi - object-oriented interface
 * @export
 * @class OrganisationSubscriptionApi
 * @extends {BaseAPI}
 */
export class OrganisationSubscriptionApi extends BaseAPI {
    /**
     * Returns the cancelled subscription details.
     * @summary Cancels the subscription of a buyer org
     * @param {OrganisationSubscriptionApiOrgSubscriptionCancelCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSubscriptionApi
     */
    public orgSubscriptionCancelCreate(requestParameters: OrganisationSubscriptionApiOrgSubscriptionCancelCreateRequest, options?: any) {
        return OrganisationSubscriptionApiFp(this.configuration).orgSubscriptionCancelCreate(requestParameters.buyerOrgId, requestParameters.subscriptionCancelRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the updated subscription details.
     * @summary Update the subscription plan or payment method for a buyer org
     * @param {OrganisationSubscriptionApiOrgSubscriptionChangeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSubscriptionApi
     */
    public orgSubscriptionChangeCreate(requestParameters: OrganisationSubscriptionApiOrgSubscriptionChangeCreateRequest, options?: any) {
        return OrganisationSubscriptionApiFp(this.configuration).orgSubscriptionChangeCreate(requestParameters.buyerOrgId, requestParameters.aaSource, requestParameters.subscriptionChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the created subscription details.
     * @summary Create a subscription for a buyer org
     * @param {OrganisationSubscriptionApiOrgSubscriptionCreateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSubscriptionApi
     */
    public orgSubscriptionCreateCreate(requestParameters: OrganisationSubscriptionApiOrgSubscriptionCreateCreateRequest, options?: any) {
        return OrganisationSubscriptionApiFp(this.configuration).orgSubscriptionCreateCreate(requestParameters.buyerOrgId, requestParameters.subscriptionCreateRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns setup intent, along with the customer and an ephemeral key
     * @summary Creates a new setup intent
     * @param {OrganisationSubscriptionApiOrgSubscriptionCreateSetupIntentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSubscriptionApi
     */
    public orgSubscriptionCreateSetupIntentCreate(requestParameters: OrganisationSubscriptionApiOrgSubscriptionCreateSetupIntentCreateRequest, options?: any) {
        return OrganisationSubscriptionApiFp(this.configuration).orgSubscriptionCreateSetupIntentCreate(requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the list of subscription plans
     * @summary List of all the available subscription plans
     * @param {OrganisationSubscriptionApiOrgSubscriptionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSubscriptionApi
     */
    public orgSubscriptionList(requestParameters: OrganisationSubscriptionApiOrgSubscriptionListRequest = {}, options?: any) {
        return OrganisationSubscriptionApiFp(this.configuration).orgSubscriptionList(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
